import api from './api';

export default async function selectEcoById(id) {
  const response = await api.get(`ecocardiograma?id=${id}`);
  return response.data;
}
